import { Role } from '@/types';

export function isValidRole(role: string): role is Role {
    return Object.values(Role).includes(role as Role);
}
